import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PATTERNS } from "../../../../globals";
import { BillsService } from '../../../../injections/bills.service';
import * as moment from 'moment';

@Component({
  selector: 'bills-generate',
  templateUrl: '../../templates/partials/bills-generate.html'
})
export class BillsGenerateComponent{

    @Input() staff;
    public period;
    public enableButtons = false;
    public showFeedBack = false;
    public showError = false;

    constructor(private billsService: BillsService){}

    public inputChange(event: any){
      this.period = event;
      var patt = new RegExp(PATTERNS.period);
      //console.log(patt.test(this.period));
      if(patt.test(this.period)){
        this.enableButtons = true;
      }
    }

    public generateUserBills(){
      this.enableButtons = false;
      this.showFeedBack = false;
      this.showError = false;
      let period = moment(this.period, "MM/YYYY").format("YYYY-MM");
      this.billsService.generateUserBills(period).subscribe(res => {
        this.setFeedBack(res);
      });
    }

    public generateCleanerBills(){
      this.enableButtons = false;
      this.showFeedBack = false;
      this.showError = false;
      let period = moment(this.period, "MM/YYYY").format("YYYY-MM");
      this.billsService.generateCleanerBills(period).subscribe(res => {
        this.setFeedBack(res);
      });
    }

    public setFeedBack(res) {
      if(res == "OK"){
        this.showFeedBack = true;
      }else{
        this.showError = true;
      }
      this.enableButtons = true;
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/staff/components/dummy/bills-generate.component.ts